// Per-environment build configuration, resolved once at import time.
//
// Every value that differs between dev / stage / prod but is NOT a secret lives
// in environments.json, checked in and reviewable in the diff. The deploy
// workflows pass exactly one variable — REACT_APP_ENV — and this module picks
// the matching entry. Nothing per-environment is spelled out in the workflows
// any more, so a deploy and its rollback cannot drift apart.
//
// Secrets and deploy-only values are deliberately NOT here: secrets belong in
// GitHub environment secrets, and S3 bucket / CloudFront ids live in
// .github/environments.json so they never reach the public bundle.
//
// Local dev: individual REACT_APP_* overrides still win (see serverUrl.js) —
// the compose stack points the app at container hostnames that no static
// manifest could describe.
import environments from "./environments.json";
import { ENV_NAME } from "./env";

const FALLBACK_ENV_NAME = "local";

export const envName = ENV_NAME || FALLBACK_ENV_NAME;

// The ONLY two environment conditions: prod (the exact name `prod`) and
// non-prod (everything else, including an unknown name). Gate on these, never
// on `envName` directly.
export const IS_PROD = envName === "prod";
export const IS_NON_PROD = !IS_PROD;

const resolved = environments[envName];

if (!resolved) {
  // eslint-disable-next-line no-console
  console.error(
    `Unknown REACT_APP_ENV "${envName}" — falling back to "${FALLBACK_ENV_NAME}". ` +
      `Valid values: ${Object.keys(environments).join(", ")}`
  );
}

// Falling back to "local" (not prod) is deliberate: a misconfigured build must
// fail loudly against localhost, never silently talk to the production API.
const environment = resolved || environments[FALLBACK_ENV_NAME];

export default environment;
